module.exports = __webpack_public_path__ + "assets/welcome_modal_banner.svg";